<template>
  <div class="pointshop-modal">
  <transition name="modal ">

    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <slot name="header">
            <div class="modal-header">
              <h2 v-html="messageHeader"> </h2>
            </div>
          </slot>

          <div class="modal-body">
            <slot name="body">
              <p> {{ messageProp }}</p>
              <hr>
              <button class="modal-default-button" @click="closeComponent()">{{close}}</button>

            </slot>
          </div>
        </div>
      </div>
    </div>

  </transition>
</div>
</template>

<script>
export default {
  props: ['messageProp', 'messageHeader'],
  data: function () {
    return {
      close: ''

    }
  },
  created() {
    this.close = this.$root.language.wsm_CloseWindow
  },
  methods: {
    closeComponent() {
      this.$emit('close-clicked');
    }
  }
}


</script>

<style lang="scss" >    
.pointshop-modal{
  --erro-red: #ff9090;
  --pointshop-turquoise: #418a90;

    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .4s ease;
    }

    button.modal-default-button {
      border: none;
      background: #4d949b;
      color: #fff;
      padding: 10px;
      margin: 0 auto;

      float: right;
      width: auto;
      margin: 16px auto 0;
      border: 1px solid white;
      display: block;
      -webkit-transition: background-color 1s ease-out;
      -moz-transition: background-color 1s ease-out;
      -o-transition: background-color 1s ease-out;
      transition: background-color 1s ease-out;
      cursor:pointer;

      &:hover{
          background-color: #2e6166;     
        }
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-container {
      position: relative;
      width: 600px;
      margin: 0px auto;
      padding: 40px 0px 70px;
      min-height: 35px;
      background-color: var(--pointshop-turquoise);
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .2s ease;
      font-family: Helvetica, Arial, sans-serif;
      color: white;
    }

    .modal-body {
      padding: 0 15px 0;


      p {
        color: white;
        text-align: center;
        font-size: 2em;
        padding: 0 15px;
        margin-bottom: 2em;
      }
    }


    .modal-enter {
      opacity: 0;
    }

    .modal-leave-active {
      opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(0.95);
      transform: scale(0.95);
    }


    .modal-header {
      height: 60px;

      h2 {
        color: white;
        font-size: 3em;
        text-align: center;
        padding: 20px 0 0;
        font-weight: 600;
      }
    }    

    @media only screen and (max-width: 700px) {
      .modal-container {
        width:85%;
      }
  }
}

.pointshop-modal.error-message {
      .modal-container {
        background-color: white;

        .fa-exclamation-circle,
        .fa-circle-check {
          font-size: 1em;
          color: var(--erro-red);
          top: 32px;
          position: absolute;
          left: 45%;

        }
      }

      button {
        background-color: var(--erro-red);
        -webkit-transition: background-color 1s ease-out;
        -moz-transition: background-color 1s ease-out;
        -o-transition: background-color 1s ease-out;
        transition: background-color 1s ease-out;
        cursor:pointer;

        &:hover{
          background-color: rgb(196, 64, 64);
        
        }
      }

      p {
        color: var(--erro-red);
      }
    }

.pointshop-modal.success-message {
      .fa-check-circle {
        font-size: 1em;
        color: white;
        top: 32px;
        position: absolute;
        left: 45%;
      }

    }
</style>